module.exports = __webpack_public_path__ + "static/img/能力开放_0.f5a3a43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/能力开放_0.jpg
// module id = 56Mp
// module chunks = 1